import store from '@/store'

export default { 
    async bind(el, binding, vnode) {
        const vm = await el
        let showMoney = store.state.user.userInfo.permission.priceView
        if(showMoney==1){
            return
        }else{
            vm.textContent = '***'
        }
    }

}